"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullscreenElement = exports.exitFullscreen = exports.requestFullscreen = void 0;
const video_client_core_1 = require("@video/video-client-core");
let iOSFullScreenElement = null;
/**
 * Cross-browser API to request fullscreen mode.
 */
function requestFullscreen(el) {
    let promise;
    if (iOSWorkaround(el)) {
        promise = requestFullscreenIOS(el);
    }
    else if (typeof el.requestFullscreen === "function") {
        // PM-2243 - When invoking the requestFullscreen method on Safari 17, there is a
        // noticeable issue where the feed resizes itself before the fullscreen transition completes.
        // This web API issue was introduced and is specific to Safari 17.
        promise = el.requestFullscreen();
    }
    else if (typeof el.webkitRequestFullScreen === "function") {
        promise = el.webkitRequestFullScreen();
    }
    else {
        promise = Promise.reject(new Error("requestFullscreen not supported"));
    }
    return promise !== null && promise !== void 0 ? promise : Promise.resolve();
}
exports.requestFullscreen = requestFullscreen;
/**
 * Cross-browser API to exit fullscreen mode.
 */
function exitFullscreen() {
    let promise;
    if (iOSWorkaround(iOSFullScreenElement)) {
        promise = exitFullscreenIOS();
    }
    else if (typeof document.exitFullscreen === "function") {
        // PM-2243 - When exiting fullscreen on Safari 17, the feed resizes
        // itself before the exit from fullscreen transition completes.
        // This web API issue was introduced and is specific to Safari 17.
        promise = document.exitFullscreen();
    }
    else if (typeof document.webkitCancelFullScreen === "function") {
        promise = document.webkitCancelFullScreen();
    }
    else {
        promise = Promise.reject(new Error("exitFullscreen not supported"));
    }
    return promise !== null && promise !== void 0 ? promise : Promise.resolve();
}
exports.exitFullscreen = exitFullscreen;
/**
 * Cross-browser API to check if fullscreen mode is active.
 */
function fullscreenElement() {
    var _a, _b, _c;
    return ((_c = (_b = (_a = document.fullscreenElement) !== null && _a !== void 0 ? _a : document.webkitFullscreenElement) !== null && _b !== void 0 ? _b : document.webkitCurrentFullScreenElement) !== null && _c !== void 0 ? _c : iOSFullScreenElement);
}
exports.fullscreenElement = fullscreenElement;
function findVideoEl(el) {
    var _a;
    if (el == null || el instanceof HTMLVideoElement) {
        return el;
    }
    return (_a = el.querySelector("video")) !== null && _a !== void 0 ? _a : null;
}
function iOSWorkaround(el) {
    const videoEl = findVideoEl(el);
    return video_client_core_1.adapter.device.isIosDevice && typeof (videoEl === null || videoEl === void 0 ? void 0 : videoEl.webkitEnterFullscreen) === "function";
}
function requestFullscreenIOS(el) {
    var _a;
    const videoEl = findVideoEl(el);
    if (videoEl == null) {
        return Promise.reject(new Error("video element not found"));
    }
    const promise = (_a = videoEl.webkitEnterFullscreen) === null || _a === void 0 ? void 0 : _a.call(videoEl);
    iOSFullScreenElement = videoEl;
    videoEl.addEventListener("webkitendfullscreen", () => {
        iOSFullScreenElement = null;
        document.dispatchEvent(new Event("fullscreenchange"));
        setTimeout(() => {
            // I am a dirty hack, please fix me :(
            videoEl.play().catch(() => {
                // ignore
            });
        }, 1000);
    }, {
        once: true,
    });
    document.dispatchEvent(new Event("fullscreenchange"));
    return promise !== null && promise !== void 0 ? promise : Promise.resolve();
}
function exitFullscreenIOS() {
    var _a;
    const promise = (_a = iOSFullScreenElement === null || iOSFullScreenElement === void 0 ? void 0 : iOSFullScreenElement.webkitCancelFullScreen) === null || _a === void 0 ? void 0 : _a.call(iOSFullScreenElement);
    return promise !== null && promise !== void 0 ? promise : Promise.resolve();
}
//# sourceMappingURL=fullscreen.js.map